export const model = {
    id: null,
    name: '', 
    // code: '',
    created_at: '',
    updated_at: ''
};
